export default __webpack_public_path__ + "static/media/rafael-sombra.b39a4842.jpg";